// extracted by mini-css-extract-plugin
export default {"iconDarkTheme":"IconDarkTheme_iconDarkTheme__t1wZc"};